<template>
  <div class="md-collapse">
    <md-list>
      <li v-if="warehousePrinters && warehousePrinters.length > 0">
          <md-field>
              <label for="activeWarehousePrinter">{{$t('pages.dashboard.warehouseprinter')}}</label>
              <md-select name="activeWarehousePrinter" id="activePrinter" v-model="activeWarehousePrinterId">
                  <md-option v-for="warehousePrinter in warehousePrinters" :value="warehousePrinter.mys_warehouseprinterid">{{warehousePrinter.mys_name}}</md-option>
              </md-select>
          </md-field>
      </li>
      <li v-if="warehouses && warehouses.length > 0">
        <md-field>
          <label for="activeWarehouse">{{$t('pages.dashboard.warehouse')}}</label>
          <md-select name="activeWarehouse" id="activeAccount" v-model="activeWarehouseId">
            <md-option v-for="warehouse in warehouses" :value="warehouse.warehouseId">{{warehouse.warehouseName}}</md-option>
          </md-select>
        </md-field>
      </li>
      <md-list-item href="#" class="dropdown">
        <drop-down>
          <a slot="title" class="dropdown-toggle" data-toggle="dropdown" v-on:click="logout">
            {{$t('buttons.logout')}}<i class="material-icons">person</i>
            <p class="hidden-lg hidden-md">{{$t('pages.dashboard.profile')}}</p>
          </a>
        </drop-down>
      </md-list-item>
    </md-list>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: 'warehouse-config-selector',
  props: {
    logout: {}
  },
  computed:{
    ...mapGetters(["user","warehouses","warehousePrinters"]),
    activeWarehouseId: {
      set(value) {
        if (!value)
          return;
        store.dispatch("setWarehouseId", value);
      },
      get() {
        return store.getters.activeWarehouseId;
      }
      },
      activeWarehousePrinterId: {
        set(value) {
          if (!value)
            return;
          store.commit("SET_WAREHOUSEPRINTERID", value)
        },
        get() {
          return store.getters.activeWarehousePrinterId;
        }
    },
  },
}
</script>